import { useAuth } from '@/contexts/AuthContext';

export const useSupabaseAuth = () => {
  return useAuth();
};
